/**
 * Takes an optional values to generate an array of pageSizeOptions for paginated tables
 * @param multiplesOf
 * @param numberOfOptions
 */
export const generatePageSizeOptions = (multiplesOf = 10, numberOfOptions = 10): number[] => {
  const optionsSize = [ ...new Array(numberOfOptions + 1).keys() ];

  return optionsSize.map(iteration => iteration * multiplesOf).slice(1, -1);
};